import { ArtworksState } from "../state/artworksState";
import {
    RECEIVE_ARTWORK_LIST,
    IS_LOADING, CLEAR_FILTERS, UPDATE_FILTERS, FETCH_ERROR,
    RECEIVE_ART_DECORATION_TYPE,RECEIVE_ART_DECORATORS_VENDORS_LIST,
    RECEIVE_ART_DECORATORS_TYPE_LIST
} from "../actions/artworkActions";
import { RECEIVE_CURRENT_USER } from "../actions/sessionActions";
import { User } from "../../models/User";

export const initState: ArtworksState = {
    fetchError: false,
    artworks: {},
    decoratorsVendorsList:[],
    decoratorsTypeList:[],
    filters: {
        account_id: "",
        identity: "",
        designNo: "",
        orderNum: "",
        usageStatus: "A",
        statusName: [],
        mainSearch: ""
    },
    statuses: [],
    loading: false,
    cleared: 0,
    count: 1,
    meta: null
}

const ArtworkReducer = (state: ArtworksState = initState, action) => {
    switch (action.type) {
        case RECEIVE_ARTWORK_LIST: {
            return {
                ...state,
                loading: false,
                artworks: { ...action.artworks },
                count: action.count,
                meta: action.meta,
            }
        }
        case RECEIVE_CURRENT_USER: {
            const user: User = action.currentUser;
            return {
                ...state,
                filters: {
                    ...state.filters,
                    account_id: user.accountId,
                    contact_id: !user.portalPermissions.Artwork[0].allowedOtherContacts
                        ? user.contactId : ""
                },
            };
        }
        case CLEAR_FILTERS: {
            const user: User = action.currentUser;
            return {
                ...state,
                filters: {
                    ...initState.filters,
                    account_id: user.accountId
                },
                cleared: state.cleared + 1
            }
        }
        case UPDATE_FILTERS: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload,
                },
            };
        }
        case FETCH_ERROR: {
            return {
                ...state,
                fetchError: true,
                loading: false
            }
        }
        case RECEIVE_ART_DECORATION_TYPE: {
            return {
                ...state,
                loading: false,
                decorationTypes: action.payload.data,
            }
        }
        case RECEIVE_ART_DECORATORS_VENDORS_LIST: {
            return {
                ...state,
                loading: false,
                decoratorsVendorsList: action.payload.data,
            }
        }
        case RECEIVE_ART_DECORATORS_TYPE_LIST: {
            return {
                ...state,
                loading: false,
                decoratorsTypeList: action.payload,                
            }
        }
        case IS_LOADING: return {
            ...state,
            loading: action.loading
        }
        default:
            return state;
    }
}

export default ArtworkReducer;